/**
 * Shared style constants for the mention card so its pieces cannot drift.
 */

/**
 * "Glass pill" surface for the on-media overlays (the platform chip and the
 * boosted badge). Near-opaque white fill over a warm hairline, never a shadow.
 * Single source so the two overlays on one card stay identical.
 *
 * No backdrop-filter: the pill is repeated on every card, and each blurred copy
 * is its own compositor layer reading the pixels behind it. Across a long grid
 * that exhausted GPU memory and the browser painted blank tiles while
 * scrolling; at 92% opacity the blur was not visible anyway.
 */
export const mediaGlassPillProps = {
  bg: 'rgba(255,255,255,0.92)',
  borderWidth: '1px',
  borderColor: 'rgba(236,232,222,0.9)',
  rounded: 'full',
} as const;

/** Avatar diameter in the card footer, shared with the skeleton so they align. */
export const MENTION_AVATAR_SIZE = '28px';

/**
 * Footer padding by density, shared between the footer and its skeleton so the
 * loading-to-loaded transition never jumps.
 */
export const mentionCardFooterPadding = (compact: boolean) => ({
  px: compact ? 3 : 3.5,
  py: compact ? 2 : 3,
});
